import React from 'react'

import { GridRowProps } from './GridRow.types'

const GridRow: React.FC<GridRowProps> = ({ grow, children }) => {
    return (
        <div
            style={{
                flexGrow: grow ? 1 : 0,
            }}
            data-testid='GridRow'
            className='r-gridrow-container'
        >
            {children}
        </div>
    )
}

export default GridRow
